/*
 *  Alert the user that there is an online session in progress
 */

import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useUpdateWhenScheduleAdvances } from '../../../data/hooks/datetimeHooks';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useSelectedSessions } from '../../../data/hooks/schedule/useSelectedSessions';
import { useIsValidWaitingRoomSessionFilter } from '../../../data/hooks/schedule/useIsValidWaitingRoomSessionFilter';
import { useVirtualRoom } from '../../../data/hooks/ui/useVirtualRoom';
import { useForceUpdate } from '../../../misc/hooks';
import ExternalLinkButton from '../../elements/Button/ExternalLinkButton/ExternalLinkButton';
import Icon from '../../elements/icons/Icon';
import SidePanelDialog from '../common/SidePanelDialog/SidePanelDialog';
import { useSessionInProgress } from '../hooks';

// list of sessions where the dialog was shown and closed (no need to put it in store because it's only relevant here)
const CLOSED_DIALOGS = [];

const ActiveOnlineSessionWarningDialog = (props) => {
    const { eventId } = useParams(),
        event = useEvent(eventId),
        selectedSessions = useSelectedSessions(event.id),
        isValidWaitingRoomSession = useIsValidWaitingRoomSessionFilter(event.id),
        session = useSessionInProgress(event.id, {
            filter: (session) => !CLOSED_DIALOGS.find((id) => id == session.id) && isValidWaitingRoomSession(session, selectedSessions),
        }),
        virtualRoom = useVirtualRoom();

    const forceUpdate = useForceUpdate();

    // Next update
    useUpdateWhenScheduleAdvances(eventId);

    // If session is already open, close the dialog
    useEffect(() => {
        if (session && virtualRoom?.programId == session?.id) {
            CLOSED_DIALOGS.push(session.id);
            forceUpdate();
        }
    });

    if (!session || virtualRoom?.programId == session.id) return null;
    if (!session.session_content_url && !session.session_description) return null;

    const handleCloseDialog = () => {
        CLOSED_DIALOGS.push(session.id);
        forceUpdate();
    };

    return (
        <SidePanelDialog className="ActiveOnlineSessionWarningDialog" onClose={handleCloseDialog}>
            <div className="description">
                {session.name && <h2>{session.name}</h2>}
                {session.location && (
                    <p className="location">
                        <Icon src="/img/location.png" color="#787878" size={14} />
                        {session.location}
                    </p>
                )}
                {session.session_content_description ? <p>{session.session_content_description}</p> : <h2 style={{ color: event.settings.primary_color }}>Live!</h2>}
            </div>

            <ExternalLinkButton
                {...session}
                eventId={event.id}
                programId={session.id}
                style={{
                    backgroundColor: event.settings.primary_color,
                    minWidth: '180px',
                }}
                onClick={handleCloseDialog}
            />
        </SidePanelDialog>
    );
};

export default ActiveOnlineSessionWarningDialog;
